var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NavMeshLoader } from "../../../shared/Libs/yuka-min";
export default function loadNavMeshFromString(fileNameNavMesh) {
    return __awaiter(this, void 0, void 0, function* () {
        let url = "/models/navmesh/" + fileNameNavMesh + ".glb";
        const loader = new NavMeshLoader();
        return loader.load(url, { mergeConvexRegions: false }).then((navMesh) => {
            return navMesh;
        });
    });
}
